export default __webpack_public_path__ + "static/media/st_goDisable.d342ccd6.jpg";